module.exports = __webpack_public_path__ + "static/media/explore112.95d46d64.webm";